import { Tooltip as MantineToolTip, TooltipProps as MantineTooltipProps } from '@mantine/core';
import toolTipStyles from './Tooltip.module.css';
import { FC } from 'react';
export type TooltipProps = MantineTooltipProps;

export const Tooltip: FC<TooltipProps> = ({ classNames, ...props }) => {
    return <MantineToolTip classNames={{ tooltip: toolTipStyles.tooltip, ...classNames }} {...props} />;
};
